import React,{useState,useEffect} from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import StateHeader from "./StateHeader";
import StateTable from "./StateTable";
import { useLocation } from "react-router-dom";
import { fetchFormData } from "../../utils/options";

const StateList = () => {
  const [permission, setPermission] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const module = queryParams.get("module");
  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const module = queryParams.get("module");
         const IsAdmin = localStorage.getItem("IsAdmin");
      if (IsAdmin === "yes") return;
      if (!roleId || !module) return;

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", module);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);

        if (!perm || perm?.pf_view === 1) {
          // topTost({
          //   title: result.message,
          //   icon: "success",
          // });
        }
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [module]);
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <StateHeader permission={permission} />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <StateTable permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default StateList;
